// import { Injectable } from '@angular/core';
import { TreeviewItem } from 'ngx-treeview';
import {TranslateService} from "./translate-service";

export class OptionTreeViewService {
    getOptions(translation: TranslateService): TreeviewItem[] {
        const itCategory = new TreeviewItem({
            text: '', value: 0, children: [
                { text: translation.getLng('COVER_PAGE'), value: 'cover', checked: false },
                { text: translation.getLng('INSTALL_CERT'), value: 'protocol', checked: false },
                { text: translation.getLng('ROOF_PLAN_OVERVIEW'), value: 'roofplanoverview', checked: false },
                { text: translation.getLng('ROOF_PLAN_SUBFRAME'), value: 'roofplansubframe', checked: false },
                { text: translation.getLng('STRING_OVERVIEW'), value: 'stringoverview', checked: false },
                { text: translation.getLng('INVERTER_PLAN'), value: 'subgenerators', checked: false },
                { text: translation.getLng('ITEM_LIST'), value: 'items', checked: false },
            ]
        });
        return [itCategory];
    }
}
